import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import '../../../scss/pages/april-fools.scss';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { Link } from 'react-scroll';
import { DemoFormShortPDFAprilFools } from '../../../components/DemoFormShortPDFAprilFools.jsx';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import ResponsiveSlider from '../../../components/ResponsiveSlider';

const Home = (props) => {

	const location = props.location;
	const defaultSettings = {
		dots: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 1150,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	};

	return (
		<Layout  bodyClass="" ontouchstart>
			<SEO title="Charting Better Galaxies Report | ChartHop" />
			<Helmet>
				<meta name="description" content="Introducing the first ever workplace Astrology report. With this data we can chart course to more equitable galaxies for all signs under the stars." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Charting Better Galaxies Report | ChartHop" />
				<meta property="og:description" content="Introducing the first ever workplace Astrology report. With this data we can chart course to more equitable galaxies for all signs under the stars." />
				<meta property="og:image" content={`https://www.charthop.com/april-fools/astrology-meta-image.png`} />
				<meta property="og:type" content="website" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Charting Better Galaxies Report | ChartHop" />
				<meta name="twitter:description" content="Introducing the first ever workplace Astrology report. With this data we can chart course to more equitable galaxies for all signs under the stars." />
				<meta name="twitter:image" content={`https://www.charthop.com/april-fools/astrology-meta-image.png`} />
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>

			<div className="april-fools">
				{/* HEADER */}
				<section className="intro sectionSpacing pb-lg-7 pb-md-3">
					<div className="container hero-formNoImage">
						<div className="introContent">
							<div className="introTitle heroTopContent mb-2">
								<img src={'/april-fools/mobiletop-header.svg'} className="bg-hero-mobile" alt="astrological-chart"></img>
								<h1 className="heroTitle">Charting Better Galaxies</h1>
								<h2 className="heroSubTitle">Your (April Fools') guide to Astrology at work</h2>
							</div>
							<DemoFormShortPDFAprilFools CBW pdfUrl={'/resources/Charting-Better-Galaxies-Report-ChartHop.pdf'} source={"resources-charting-better-galaxies-PDF-contentdownload-header"} />
							<div>
								<Link to="introductionDesktop" smooth={true} offset={-70} duration={500}><div className="arrow bounce desktop"></div></Link>
							</div>
						</div>
					</div>
				</section>

				{/* SUB NAVBAR */}
				<section className="subNavigationMenu-workplace">
					<div className="container">
						
						
						<div className="navigation-element mobile">
							<Link to="introduction" smooth={true} offset={-70} duration={500}>Introduction</Link>
						</div>
						<div className="navigation-element desktop">
							<Link to="introductionDesktop" smooth={true} offset={-70} duration={500}>Introduction</Link>
						</div>
						<div className="separator sep1">|</div>
						<div className="navigation-element mobile">
							<Link to="keyFindings" smooth={true} offset={-70} duration={500}>Key Findings</Link>
						</div>
						<div className="navigation-element desktop">
							<Link to="keyFindingsDesktop" smooth={true} offset={-70} duration={500}>Key Findings</Link>
						</div>
						<div className="separator sep2">|</div>
						<div className="navigation-element mobile">
							<Link to="workplaceAstroGuide" smooth={true} offset={-70} duration={500}>Workplace<br></br>Astro Guide</Link>
						</div> 
						<div className="navigation-element desktop">
							<Link to="workplaceAstroGuideDesktop" smooth={true} offset={-70} duration={500}>Workplace<br></br>Astro Guide</Link>
						</div> 
						<div className="separator sep3">|</div>
						<div className="navigation-element">
							<Link to="earthSigns" smooth={true} offset={-70} duration={500}>Earth Signs<br></br>Overstaffed<br></br>& Underpaid</Link>
						</div>
						<div className="separator sep4">|</div>
						<div className="navigation-element">
							<Link to="fireSigns" smooth={true} offset={-70} duration={500}>Fire Signs Blast<br></br>to the Top</Link>
						</div>
						<div className="separator sep5">|</div>
						<div className="navigation-element">
							<Link to="waterSigns" smooth={true} offset={-70} duration={500}>Water Signs<br></br>Dominate<br></br>People-Facing Roles</Link>
						</div>
						<div className="separator sep6">|</div>
						<div className="navigation-element">
							<Link to="airSigns" smooth={true} offset={-70} duration={500}>Air Signs as<br></br>Inconsistent<br></br>as Ever</Link>
						</div>
						<div className="separator sep7">|</div>
						<div className="navigation-element">
							<Link to="conclusionSection1" smooth={true} offset={-70} duration={500}>Conclusion</Link>
						</div>
						<div className="arrow-container-mobile">
							<Link to="introduction" smooth={true} offset={-70} duration={500}><div className="arrow bounce mobile"></div></Link>
						</div>
					</div>
				</section>

			

				{/* INTRODUCTION */}
				<section className="introductionSection mobile" id="introduction">
					<div className="container">
						<h2 className="text-center">Introduction</h2>
						<div className="introductionContentBox row">
							<div className="col-12">
							<p>Charting Better Galaxies is the first report to shine a light on wage and
							representation gaps by Astrological Sign.</p>
								<br></br>
								<p>Companies use ChartHop to manage their People Data, giving ChartHop unprecedented access to real‑time salary, equity,
							managerial, and Astrological data. For this report, we aggregated and anonymized the data of tens of thousands of
									employees from private and public tech companies.</p>
								<br></br>
								<p>We found significant trends in how leadership representation, functional role type and compensation vary across Astrological sign and sign type.</p>
								<br></br>
								<div>
									<img src={'/april-fools/air-signs-graph-mobile.svg'} className="introductionDesktopddShadow" alt="graph-1"></img>
								</div>
								<br></br>
								<p>Much to the surprise of our astro-skeptic readers, the trends we uncovered align to common personality traits associated with people’s sign. Charting Better Galaxies  pairs these findings with Astrological Personality Analytics to question how
							(sub)conscious perceptions of personality traits are driving these trends.</p>
								<br></br>
								<p>Clarity into Astrological Sign distribution is not going to solve all of our workplace challenges. But, it’s an important step in understanding how sign- and personality-based stereotyping inform compensation, promotions, vocation, and more.</p>
								<br></br>
								<p>Organizations need data and resources to address workplace inequities. With ChartHop’s actionable Astrological Insights, leaders now have the context they need to address inequities and create a better workplace for everyone under the stars.</p>
							</div>
						</div>
						<div className="cristal-ball">
							<img src="/april-fools/cristal-ball.svg" alt=""/>
						</div>
					</div>
				</section>

				{/* INTRODUCTION */}
				<section className="introductionSection sectionSpacing desktop" id="introductionDesktop">
					<div className="container">
						<h2 className="text-center">Introduction</h2>
						<div className="introductionContentBox row">
							<div className="col-12">
								<p>Charting Better Galaxies is the first report to shine a light on wage and
							representation gaps by Astrological Sign.</p>
								<br></br>
								<p>Companies use ChartHop to manage their People Data, giving ChartHop unprecedented access to real‑time salary, equity,
							managerial, and Astrological data. For this report, we aggregated and anonymized the data of tens of thousands of
									employees from private and public tech companies.</p>
								<br></br>
								<p>We found significant trends in how leadership representation, functional role type and compensation vary across Astrological sign and sign type.</p>
								<br></br>
								<div>
									<img src={'/april-fools/Static7-by-Astrological-Sign.svg'} className="addShadow mt-lg-5 mb-lg-5" alt="graph-1"></img>
								</div>
								<br></br>
								<p>Much to the surprise of our astro-skeptic readers, the trends we uncovered align to common personality traits associated with people’s sign. Charting Better Galaxies  pairs these findings with Astrological Personality Analytics to question how
							(sub)conscious perceptions of personality traits are driving these trends.</p>
								<br></br>
								<p>Clarity into Astrological Sign distribution is not going to solve all of our workplace challenges. But, it’s an important step in understanding how sign- and personality-based stereotyping inform compensation, promotions, vocation, and more.</p>
								<br></br>
								<p>Organizations need data and resources to address workplace inequities. With ChartHop’s actionable Astrological Insights, leaders now have the context they need to address inequities and create a better workplace for everyone under the stars.</p>
							</div>
						</div>
						<div className="cristal-ball">
							<img src="/april-fools/cristal-ball.svg" alt="" />
						</div>
					</div>
				</section>

				{/*KEY FINDINGS*/}
				
					<section className="keyFindings sectionSpacing desktop" id="keyFindingsDesktop">
					<div className="container">
							<h2 className="text-center mb-lg-4 mt-lg-4 mb-3 mt-3">Key Findings</h2>
							<div className="keyFinding-card-container">
								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons-1.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">Virgos are the most highly represented sign across the industry.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=Ahem%20%40ChartHop...as%20a%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20I%20have%20several%2C%20if%20not%20many%2C%20complaints%3A%0A%0AHow%20are%20we%20the%20most%20represented%20in%20tech%2C%20yet%20not%20one%20of%20the%20highest%20compensated%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>

								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons–2.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">There is a representation gap in senior leadership. Fire Signs make up 40% of leadership positions.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=I%20feel%20so%20seen%20%40ChartHop%20%F0%9F%A4%97%0A%0A%23Leos%20%E2%99%8C%EF%B8%8F%20%20%23Sagittarius%E2%80%99%20%E2%99%90%EF%B8%8F%20%20%23Aries%20%E2%99%88%EF%B8%8F%20%20are%20born%20leaders.%0A%0AIt%E2%80%99s%20no%20surprise%20we%20make%20up%2040%25%20of%20leadership%20positions%20in%20tech%20%F0%9F%92%A5&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>

								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons–3.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">Earth Signs are paid the lowest compared to other sign types.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=W%20O%20W!%20%40ChartHop%20has%20me%20fully%20shook%20%F0%9F%98%B1%20%0A%0AApparently%20%23EarthSigns%20-%20%23Capricorn%20%E2%99%91%EF%B8%8F%20%20%23Taurus%20%E2%99%89%EF%B8%8F%20%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20-%20are%20the%20lowest%20paid%20in%20tech%20%F0%9F%A4%A6%E2%80%8D%E2%99%80%EF%B8%8F%20%20%20%0A%0AWhat%20can%20we%20do%20to%20achieve%20pay%20equality%20for%20all%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>

								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons–4.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">Water Signs are most likely to have support roles - Customer Success, People/HR, and Tech Support.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=We%20feel%20(a%20lot%2C%20but%20also)%20so%20seen%20%40ChartHop%20%20%F0%9F%91%80%20%0A%0A%23Cancers%20%E2%99%8B%EF%B8%8F%20%20%23Pisces%20%E2%99%93%EF%B8%8F%20%20%23Scorpios%20%E2%99%8F%EF%B8%8F%20%20really%20do%20love%20helping%20others%20%E2%9D%A4%EF%B8%8F%20%20%0A%0AHow%20does%20that%20impact%20our%20career%20choice%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>

								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons–5.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">Even though Earth Signs are the lowest paid by sign type, Libras are the lowest paid sign overall.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=Alright%20%23Libras%20%E2%99%8E%EF%B8%8F%20%20%40ChartHop%20has%20made%20it%20clear%20that%20we%20gotta%20start%20securing%20our%20bag%F0%9F%92%B0%20%0A%0AWhat%20are%20we%20gonna%20do%20about%20it%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>

								<div className="keyFinding-card">
									<div>
									<div className="centerImageCard">
										<img className="img-card" src="/april-fools/Key-Findings-icons–6.svg" alt="KeyFinding" />
									</div>
									<p className="sign-description text-left">True to their nature, Air Signs as a whole defied categorization and could not yield any tangible trends.</p>
									</div>
									<div className="share-twitter">
										<div className="twitter-container">
											<p className="text-center"><a className="super" href="https://twitter.com/share?text=Ok%20%40ChartHop%2C%20the%20%23AirSigns%20get%20it.%20%0A%0A%23Libra%20%E2%99%8E%EF%B8%8F%20%20%23Gemini%20%E2%99%8A%EF%B8%8F%20%20%23Aquarius%20%E2%99%92%EF%B8%8F%20-%20%20we%E2%80%99re%20perfect%2C%20we%E2%80%99re%20beautiful%2C%20and%20no%20one%20understands%20us.%20%0A%0AHow%20unpredictable%20are%20we%20in%20the%20workplace%2C%20really%3F%20%F0%9F%A4%94&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				
			{/* KEYFINDINGS MOBILE CAROUSEL */}
				<section className="keyFindingsMobile sectionSpacing mobile" id="keyFindings">
						<h2 className="text-center mb-lg-4 mt-lg-4 mb-3 mt-3">Key Findings</h2>
						<ResponsiveSlider settings={defaultSettings} elements={[
							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons-1.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">Virgos are the most highly represented sign. Yet they make below average salary.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Ahem%20%40ChartHop...as%20a%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20I%20have%20several%2C%20if%20not%20many%2C%20complaints%3A%0A%0AHow%20are%20we%20the%20most%20represented%20in%20tech%2C%20yet%20one%20of%20the%20lowest%20compensated%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons–2.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">There is a representation gap in senior leadership. On average, Fire Signs make up 40% of leadership positions.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=I%20feel%20so%20seen%20%40ChartHop%20%F0%9F%A4%97%0A%0A%23Leos%20%E2%99%8C%EF%B8%8F%20%20%23Sagittarius%E2%80%99%20%E2%99%90%EF%B8%8F%20%20%23Aries%20%E2%99%88%EF%B8%8F%20%20are%20born%20leaders.%0A%0AIt%E2%80%99s%20no%20surprise%20we%20make%20up%2040%25%20of%20leadership%20positions%20in%20tech%20%F0%9F%92%A5&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons–3.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">Earth Signs are the lowest paid across industries and roles by sign type.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=W%20O%20W!%20%40ChartHop%20has%20me%20fully%20shook%20%F0%9F%98%B1%20%0A%0AApparently%20%23EarthSigns%20-%20%23Capricorn%20%E2%99%91%EF%B8%8F%20%20%23Taurus%20%E2%99%89%EF%B8%8F%20%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20-%20are%20the%20lowest%20paid%20in%20tech%20%F0%9F%A4%A6%E2%80%8D%E2%99%80%EF%B8%8F%20%20%20%0A%0AWhat%20can%20we%20do%20to%20achieve%20pay%20equality%20for%20all%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons–4.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">Water Signs are most likely to have support roles - Customer Success, People/HR, and Tech Support.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=We%20feel%20(a%20lot%2C%20but%20also)%20so%20seen%20%40ChartHop%20%20%F0%9F%91%80%20%0A%0A%23Cancers%20%E2%99%8B%EF%B8%8F%20%20%23Pisces%20%E2%99%93%EF%B8%8F%20%20%23Scorpios%20%E2%99%8F%EF%B8%8F%20%20really%20do%20love%20helping%20others%20%E2%9D%A4%EF%B8%8F%20%20%0A%0AHow%20does%20that%20impact%20our%20career%20choice%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons–5.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">Even though Earth Signs are the lowest paid by sign type, Libras are the lowest paid sign overall.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Alright%20%23Libras%20%E2%99%8E%EF%B8%8F%20%20%40ChartHop%20has%20made%20it%20clear%20that%20we%20gotta%20start%20securing%20our%20bag%F0%9F%92%B0%20%0A%0AWhat%20are%20we%20gonna%20do%20about%20it%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="keyFinding-card">
								<div className="centerImageCard">
									<img className="img-card" src="/april-fools/Key-Findings-icons–6.svg" alt="KeyFinding" />
								</div>
								<p className="sign-description text-left">True to their nature, Air Signs as a whole defied categorization and could not yield any tangible trends.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Ok%20%40ChartHop%2C%20the%20%23AirSigns%20get%20it.%20%0A%0A%23Libra%20%E2%99%8E%EF%B8%8F%20%20%23Gemini%20%E2%99%8A%EF%B8%8F%20%20%23Aquarius%20%E2%99%92%EF%B8%8F%20-%20%20we%E2%80%99re%20perfect%2C%20we%E2%80%99re%20beautiful%2C%20and%20no%20one%20understands%20us.%20%0A%0AHow%20unpredictable%20are%20we%20in%20the%20workplace%2C%20really%3F%20%F0%9F%A4%94&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						]}></ResponsiveSlider>

					<div className="starFooter mobile">
						<img src="/april-fools/key-findings-mobile-footer.svg" alt=""></img>
					</div>
				</section>

				{/* GET REPORT BOX */}
				<section className="getReport-box sectionSpacing only-desktop">
					<div className="container" id="getReport">
						<div className="row">
							<div className="col-md-6 col-12 marginMobile">
								<p className="getReport--main--text">Download the full report</p>
								<p className="getReport--main--text">for deeper Astrological Insights.</p>
							</div>
							<div className="col-md-6 col-12">
								<DemoFormShortPDFAprilFools CBW pdfUrl={'/resources/Charting-Better-Galaxies-Report-ChartHop.pdf'} source={"resources-charting-better-galaxies-PDF-contentdownload-box1"} />
							</div>
						</div>
					</div>
				</section>

					{/*Workplace Astroguide*/}
					<section className="WorkplaceAstroguide mobile" id="workplaceAstroGuide">
					<div className="container">
						<h2 className="hero-title text-center mb-lg-2 mb-3">The Workplace Astroguide</h2>
						<p className="hero-subtitle text-center mb-lg-4 mb-3">Before we dive into the data, how does your Astrological sign show up at work?</p>
						<h3 className="astro-title text-center mb-1">Fire Signs</h3>
						<ResponsiveSlider settings={defaultSettings} elements={[
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-aries.svg" alt="Aries" />
								<p className="sign-title text-center">Aries</p>
								<p className="sign-date text-center">3/21 - 4/20</p>
								<p className="sign-description text-left">You are a born leader, bold, and ambitious. Mind your competitive streak, not everything is a race.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...%20thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%27m%20an%20%23Aries%E2%99%88%EF%B8%8F%0A%0AWe%27re%20strong%20and%20passionate%20leaders%20-%0A%0ABut%20tend%20to%20have%20a%20competitive%20streak%20that%20can%20lead%20to%20burnout%20and%20aggression%F0%9F%91%80%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Leo.svg" alt="Leo" />
								<p className="sign-title text-center">Leo</p>
								<p className="sign-date text-center">7/21 - 8/20</p>
								<p className="sign-description text-left">You're a collaborator who can steer teams towards a unified goal. Remember to share the spotlight.
							</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...%20thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%27m%20a%20%23Leo%20%E2%99%8C%EF%B8%8F%0A%0AWe%20are%20animated%20and%20brave%20leaders%20%20-%0A%0ABut%20we%20can%20trend%20towards%20show-boating%20and%20attention-seeking%20%F0%9F%91%80%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Sagi.svg" alt="Sagittarius" />
								<p className="sign-title text-center">Sagittarius</p>
								<p className="sign-date text-center">11/21 - 12/20</p>
								<p className="sign-description text-left">You're a bold and optimistic thinker. Avoid overly procedural and mundane workplaces.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Sagittarius%20%E2%99%90%EF%B8%8F%0A%0AWe%20are%20enthusiastic%20and%20adventurous%20-%20%0A%0ABut%20we%20live%20for%20provocation%20in%20a%20stuffy%20environment%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F%20&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						]}></ResponsiveSlider>


						<h3 className="astro-title text-center mt-5">Earth Signs</h3>
						<ResponsiveSlider settings={defaultSettings} elements={[
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Taurus.svg" alt="Taurus" />
								<p className="sign-title text-center">Taurus</p>
								<p className="sign-date text-center">4/21 - 5/20</p>
								<p className="sign-description text-left">You're a hard working and methodical leader. Remember to keep an open mind in conflict.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Taurus%20%E2%99%89%EF%B8%8F%20%20%0A%0AWe%20are%20hardworking%2C%20stable%20and%20reliable%20-%0A%0ABut%20we%20can%20be%20stubborn%20and%20fixed%20in%20our%20ways%20%F0%9F%91%80%20%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Virgo.svg" alt="Virgo" />
								<p className="sign-title text-center">Virgo</p>
								<p className="sign-date text-center">8/21 - 9/20</p>
								<p className="sign-description text-left">When it's time to get something done, you're everyone's best friend. Take a deep breath and be mindful of micro-managing.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20%0A%0AWe%20are%20masters%20of%20process%20and%20organization%20-%20%0A%0ABut%20we%20can%20get%20too%20stuck%20in%20the%20details%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Capricorn.svg" alt="Capricorn" />
								<p className="sign-title text-center">Capricorn</p>
								<p className="sign-date text-center">12/21 - 1/20</p>
								<p className="sign-description text-left">You're ambitious, competent, and dependable. Remember that a little vulnerability goes a long way.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Capricorn%20%E2%99%91%EF%B8%8F%20%20%0A%0AWe%20are%20hardworking%20and%20dependendable%20-%20%0A%0ABut%20we%20can%20come%20off%20as%20lacking%20warmth%20and%20distant%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						]}></ResponsiveSlider>


						<h3 className="astro-title text-center mt-5">Air Signs</h3>
						<ResponsiveSlider settings={defaultSettings} elements={[
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Gemi.svg" alt="Gemini" />
								<p className="sign-title text-center">Gemini</p>
								<p className="sign-date text-center">5/21 - 6/20</p>
								<p className="sign-description text-left">You have big and creative ideas. Yet, you struggle to move forward with decisive action.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Gemini%20%E2%99%8A%EF%B8%8F%20%20%0A%0AWe%20are%20smart%20and%20multifaceted%20-%0A%0ABut%20we%20tend%20to%20take%20on%20too%20much%20and%20get%20easily%20overwhelmed%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Libra.svg" alt="Libra" />
								<p className="sign-title text-center">Libra</p>
								<p className="sign-date text-center">9/21 - 10/20</p>
								<p className="sign-description text-left">You're fair and level-headed but balk in conflict. Identify ways to advocate for yourself.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Libra%20%E2%99%8E%EF%B8%8F%20%20%0A%0AWe%20are%20even-keel%20and%20fair%20-%20%0A%0ABut%20we%20can%20get%20very%20uncomfortable%20with%20imbalance%20and%20conflict%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Aqua.svg" alt="Aquarius" />
								<p className="sign-title text-center">Aquarius</p>
								<p className="sign-date text-center">1/21 - 2/20</p>
								<p className="sign-description text-left">You're independent and outgoing. Be mindful of your tendency to not listen to others.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Aquarius%20%E2%99%92%EF%B8%8F%20%20%0A%0AWe%20are%20fun%20and%20outgoing%20-%20%0A%0ABut%20we%20can%20be%20judgmental%20and%20detached%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						]}></ResponsiveSlider>


						<h3 className="astro-title text-center mt-5">Water Signs</h3>
						<ResponsiveSlider settings={defaultSettings} elements={[
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Cancer.svg" alt="Cancer" />
								<p className="sign-title text-center">Cancer</p>
								<p className="sign-date text-center">6/21 - 7/20</p>
								<p className="sign-description text-left">You're loyal and steadfast. Sometimes your personal feelings may cloud your professional judgement.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Cancer%20%E2%99%8B%EF%B8%8F%20%20%0A%0AWe%20are%20loyal%20and%20nurturing%20-%0A%0ABut%20we%20can%20be%20moody%20and%20emotional%20when%20set%20off%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Scorpio.svg" alt="Scorpio" />
								<p className="sign-title text-center">Scorpio</p>
								<p className="sign-date text-center">10/21 - 11/20</p>
								<p className="sign-description text-left">You're strong-willed and charming. Beware of letting your intensity and secretiveness sour your relationships.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Scorpio%20%E2%99%8F%EF%B8%8F%20%20%0A%0AWe%20are%20perceptive%20and%20charming%20-%20%0A%0ABut%20we%20can%20be%20unreadable%20and%20secretive%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>,

							<div className="sign-card">
								<img className="img-card" src="/april-fools/Icon-Pisces.svg" alt="Pisces" />
								<p className="sign-title text-center">Pisces</p>
								<p className="sign-date text-center">2/21 - 3/20</p>
								<p className="sign-description text-left">You're a highly creative and cerebral thinker. Be mindful of distractions.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Pisces%27%20%E2%99%93%EF%B8%8F%20%20%0A%0AWe%20are%20intuitive%20and%20unique%20visionaries%20-%20%0A%0ABut%20we%20can%20have%20a%20tenuous%20tether%20to%20reality%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						]}></ResponsiveSlider>

					</div>
				</section>

				<section className="WorkplaceAstroguide sectionSpacing desktop" id="workplaceAstroGuideDesktop">
					<div className="container">
						<h2 className="hero-title text-center mb-lg-2 mb-3">The Workplace Astroguide</h2>
						<p className="hero-subtitle text-center mb-lg-4 mb-3">Before we dive into the data, how does your Astrological sign show up at work?</p>
						<h3 className="astro-title text-center mb-1">Fire Signs</h3>
						<div className="sign-card-container">
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-aries.svg" alt="Aries" />
								<p className="sign-title text-center">Aries</p>
								<p className="sign-date text-center">3/21 - 4/20</p>
								<p className="sign-description text-left">You are a born leader, bold,
								and ambitious. Mind your
								competitive streak, not
								everything is a race.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...%20thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%27m%20an%20%23Aries%E2%99%88%EF%B8%8F%0A%0AWe%27re%20strong%20and%20passionate%20leaders%20-%0A%0ABut%20tend%20to%20have%20a%20competitive%20streak%20that%20can%20lead%20to%20burnout%20and%20aggression%F0%9F%91%80%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card middle">
								<img className="img-card" src="/april-fools/icon-Leo.svg" alt="Leo" />
								<p className="sign-title text-center">Leo</p>
								<p className="sign-date text-center">7/21 - 8/20</p>
								<p className="sign-description text-left">You're a collaborator who can
								steer teams towards a unified
								goal. Remember to share the
								spotlight.
							</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...%20thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%27m%20a%20%23Leo%20%E2%99%8C%EF%B8%8F%0A%0AWe%20are%20animated%20and%20brave%20leaders%20%20-%0A%0ABut%20we%20can%20trend%20towards%20show-boating%20and%20attention-seeking%20%F0%9F%91%80%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Sagi.svg" alt="Sagittarius" />
								<p className="sign-title text-center">Sagittarius</p>
								<p className="sign-date text-center">11/21 - 12/20</p>
								<p className="sign-description text-left">You're a bold and optimistic
								thinker. Avoid overly-
								procedural and mundane
								workplaces.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Sagittarius%20%E2%99%90%EF%B8%8F%0A%0AWe%20are%20enthusiastic%20and%20adventurous%20-%20%0A%0ABut%20we%20live%20for%20provocation%20in%20a%20stuffy%20environment%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F%20&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>

						<h3 className="astro-title text-center mt-8">Earth Signs</h3>
						<div className="sign-card-container">
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Taurus.svg" alt="Taurus" />
								<p className="sign-title text-center">Taurus</p>
								<p className="sign-date text-center">4/21 - 5/20</p>
								<p className="sign-description text-left">You're a hard working and
								methodical leader. Remember
								to keep an open mind in
								conflict.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Taurus%20%E2%99%89%EF%B8%8F%20%20%0A%0AWe%20are%20hardworking%2C%20stable%20and%20reliable%20-%0A%0ABut%20we%20can%20be%20stubborn%20and%20fixed%20in%20our%20ways%20%F0%9F%91%80%20%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card middle">
								<img className="img-card" src="/april-fools/icon-Virgo.svg" alt="Virgo" />
								<p className="sign-title text-center">Virgo</p>
								<p className="sign-date text-center">8/21 - 9/20</p>
								<p className="sign-description text-left">When it's time to get
								something done, you're
								everyone's best friend. Take a
							deep breath and be mindful of
								micro-managing.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Virgo%20%E2%99%8D%EF%B8%8F%20%20%0A%0AWe%20are%20masters%20of%20process%20and%20organization%20-%20%0A%0ABut%20we%20can%20get%20too%20stuck%20in%20the%20details%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Capricorn.svg" alt="Capricorn" />
								<p className="sign-title text-center">Capricorn</p>
								<p className="sign-date text-center">12/21 - 1/20</p>
								<p className="sign-description text-left">You're ambitious, competent,
								and dependable. Remember
								that a little vulnerability goes
								a long way.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Capricorn%20%E2%99%91%EF%B8%8F%20%20%0A%0AWe%20are%20hardworking%20and%20dependendable%20-%20%0A%0ABut%20we%20can%20come%20off%20as%20lacking%20warmth%20and%20distant%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>

						<h3 className="astro-title text-center mt-8">Air Signs</h3>
						<div className="sign-card-container">
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Gemi.svg" alt="Gemini" />
								<p className="sign-title text-center">Gemini</p>
								<p className="sign-date text-center">5/21 - 6/20</p>
								<p className="sign-description text-left">You have big and creative
								ideas. Yet, you struggle to
								move forward with decisive
								action.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Gemini%20%E2%99%8A%EF%B8%8F%20%20%0A%0AWe%20are%20smart%20and%20multifaceted%20-%0A%0ABut%20we%20tend%20to%20take%20on%20too%20much%20and%20get%20easily%20overwhelmed%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card middle">
								<img className="img-card" src="/april-fools/icon-Libra.svg" alt="Libra" />
								<p className="sign-title text-center">Libra</p>
								<p className="sign-date text-center">9/21 - 10/20</p>
								<p className="sign-description text-left">You're fair and level-headed
								but balk in conflict. Identify
								ways to advocate for yourself.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Libra%20%E2%99%8E%EF%B8%8F%20%20%0A%0AWe%20are%20even-keel%20and%20fair%20-%20%0A%0ABut%20we%20can%20get%20very%20uncomfortable%20with%20imbalance%20and%20conflict%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Aqua.svg" alt="Aquarius" />
								<p className="sign-title text-center">Aquarius</p>
								<p className="sign-date text-center">1/21 - 2/20</p>
								<p className="sign-description text-left">You're independent and
								outgoing. Be mindful of your
								tendency to not listen to
								others.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Aquarius%20%E2%99%92%EF%B8%8F%20%20%0A%0AWe%20are%20fun%20and%20outgoing%20-%20%0A%0ABut%20we%20can%20be%20judgmental%20and%20detached%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>

						<h3 className="astro-title text-center mt-8">Water Signs</h3>
						<div className="sign-card-container">
							<div className="sign-card">
								<img className="img-card" src="/april-fools/icon-Cancer.svg" alt="Cancer" />
								<p className="sign-title text-center">Cancer</p>
								<p className="sign-date text-center">6/21 - 7/20</p>
								<p className="sign-description text-left">You're loyal and steadfast.
								Sometimes your personal
								feelings may cloud your
								professional judgement.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Cancer%20%E2%99%8B%EF%B8%8F%20%20%0A%0AWe%20are%20loyal%20and%20nurturing%20-%0A%0ABut%20we%20can%20be%20moody%20and%20emotional%20when%20set%20off%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card middle">
								<img className="img-card" src="/april-fools/icon-Scorpio.svg" alt="Scorpio" />
								<p className="sign-title text-center">Scorpio</p>
								<p className="sign-date text-center">10/21 - 11/20</p>
								<p className="sign-description text-left">You're strong-willed and
								charming. Beware of letting
								your intensity and
								secretiveness sour your
								relationships.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%20%0A%0AI%E2%80%99m%20a%20%23Scorpio%20%E2%99%8F%EF%B8%8F%20%20%0A%0AWe%20are%20perceptive%20and%20charming%20-%20%0A%0ABut%20we%20can%20be%20unreadable%20and%20secretive%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>

							<div className="sign-card">
								<img className="img-card" src="/april-fools/Icon-Pisces.svg" alt="Pisces" />
								<p className="sign-title text-center">Pisces</p>
								<p className="sign-date text-center">2/21 - 3/20</p>
								<p className="sign-description text-left">You're a highly creative and
								cerebral thinker. Be mindful of
								distractions.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-center"><a className="super" href="https://twitter.com/share?text=Well...thanks%20%40ChartHop.%20This%20resonates.%0A%0AI%E2%80%99m%20a%20%23Pisces%27%20%E2%99%93%EF%B8%8F%20%20%0A%0AWe%20are%20intuitive%20and%20unique%20visionaries%20-%20%0A%0ABut%20we%20can%20have%20a%20tenuous%20tether%20to%20reality%20%F0%9F%91%80%20%0A%0ADoes%20your%20%23Astrology%20Sign%20show%20up%20in%20the%20workplace%3F&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/data-report/twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* GET REPORT BOX */}
				<section className="getReport-box sectionSpacing only-desktop">
					<div className="container" id="getReport">
						<div className="row">
							<div className="col-md-6 col-12 marginMobile">
								<p className="getReport--main--text">Download the full report</p>
								<p className="getReport--main--text">for deeper Astrological Insights.</p>
							</div>
							<div className="col-md-6 col-12">
								<DemoFormShortPDFAprilFools CBW pdfUrl={'/resources/Charting-Better-Galaxies-Report-ChartHop.pdf'} source={"resources-charting-better-galaxies-PDF-contentdownload-box2"} />
							</div>
						</div>
					</div>
				</section>


				{/* EARTH SIGN */}

				<section className="EarthSignSection sectionSpacing" id="earthSigns">
					<div className="container">
						<h2 className="text-center mb-lg-5 mb-4 section-title">1. Earth Signs <br className="tablet"/> (Capricorn,  <br className="mobile"/> Taurus & Virgo) <br/> Overstaffed & Underpaid</h2>
						<p className="hero-subtitle mb-lg-6 mb-5"><strong>It may shock some readers to know that there is, in fact, an Astrological wage gap.</strong> In fact, Astrologically-based inequality is deeply
						embedded in our workplaces. It stems from centuries-old sign-based stereotyping that affects our present in impactful ways.</p>
						<div className="row align-items-center mb-7">
							<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
								<p><strong>Earth Signs as a whole made up the majority of
									workplaces at 36%. </strong> Yet, despite their strong representation,
							they are the lowest paid sign type in the zodiac.</p>
							</div>
							<div className="col-md-6 col-12 pl-md-2">
								<img src={'/april-fools/static1.svg'} className="desktop addShadow" alt="graph-1"></img>
								<img src={'/april-fools/Static1-mobile.svg'} className="mobile image addShadow" alt="graph-1"></img>
							</div>
						</div>
						<div className="row desktop align-items-center mb-7">
							<div className="desktop col-md-6 col-12 pr-md-2 mb-md-0 mb-2">
								<img src={'/april-fools/Static2.svg'} className="addShadow" alt="graph-2"></img>
							</div>
							<div className="col-md-6 col-12 pl-md-2">
								<p>After investigating the root causes of these disparities, our
									researchers found that these trends are largely driven by <strong>Earth Signs' disproportionate makeup of
									individual contributors (ICs) at 40%</strong>.</p>
							</div>
							<div className="mobile col-md-6 col-12 pr-md-2 mb-md-0 mb-2 mt-2">
								<img src={'/april-fools/Static2-mobile.svg'} className="addShadow" alt="graph-2"></img>
							</div>
						</div>
						<div className="row align-items-center mb-13">
							<div className="col-md-6 col-12 pr-md-2 mb-md-0 mb-3">
								<p>Our analysts believe this discriminatory behavior is rooted
								in Earth Signs’ industrious and high-achieving work ethic.
								They are historically less likely to advocate for themselves
							for key leadership positions and advancements in pay.</p>
							</div>
							<div className="col-md-6 col-12 pl-md-2">
								<img src={'/april-fools/Static3.svg'} className="desktop addShadow" alt="graph-3"></img>
								<img src={'/april-fools/Static3-mobile.svg'} className="mobile addShadow" alt="graph-3"></img>
							</div>
						</div>
						<div className="business-meaning-container-bis-left">
							<img className="business-meaning-img" src="/april-fools/4-Cards-business.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left">What this means for your business:</h2>
								<p className="text-left mb-1">Value and elevate those with a knack for process and structure to leadership positions.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AThose%20with%20a%20knack%20for%20process%20and%20structure%20shouldn%27t%20get%20stuck%20as%20individual%20contributors.%0A%0AElevate%20them%20to%20leadership%20positions%20too!%0A%0A%23RepresentationMatters%20%23EqualPay%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AThose%20with%20a%20knack%20for%20process%20and%20structure%20shouldn%27t%20get%20stuck%20as%20individual%20contributors.%0A%0AElevate%20them%20to%20leadership%20positions%20too!%0A%0A%23RepresentationMatters%20%23EqualPay%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>

						<div className="business-meaning-container-bis-left-mobile">
							<img className="business-meaning-img" src="/april-fools/4-Cards-business.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left">What this means for your business:</h2>
								<p className="text-left mb-1">Value and elevate those with a knack for process and structure to leadership positions.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AThose%20with%20a%20knack%20for%20process%20and%20structure%20shouldn%27t%20get%20stuck%20as%20individual%20contributors.%0A%0AElevate%20them%20to%20leadership%20positions%20too!%0A%0A%23RepresentationMatters%20%23EqualPay%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AThose%20with%20a%20knack%20for%20process%20and%20structure%20shouldn%27t%20get%20stuck%20as%20individual%20contributors.%0A%0AElevate%20them%20to%20leadership%20positions%20too!%0A%0A%23RepresentationMatters%20%23EqualPay%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>

					</div>
				</section>

				{/* FIRE SIGN */}

				<section className="fireSignsSection sectionSpacing" id="fireSigns">
					<div className="container">
						<h2 className="text-center mb-lg-5 mb-4">2. Fire Signs <br className="tablet" /> (Aries, Leo & Sagittarius) <br/> Blast to the Top</h2>
						<p>Compared to other sign types, <strong>Fire Signs dominate Executive positions at 40%</strong> -- two times as much as Water Signs
					and four times as much as Earth Signs.</p>
						<br></br>
						<p>Through a deft combination of combativeness, skill, and show-boating, Fire Signs have secured their spot in key executive and leadership positions across the tech industry.</p>
						<div className="mt-2 graph">
							<div className="row mb-2 mt-2">
								<div className="col-md-6 col-12 pr-md-4 mb-md-0 mb-4 mb-lg-2 mb-lg-4 mt-lg-4 mx-auto  text-center">
									<img className="pieGraph desktop addShadow" src={'/april-fools/Static4-Fire-signs-a.svg'} alt="graph-4-1"></img>
									<img className="pieGraph mobile addShadow" src={'/april-fools/Static5-Fire-signs-a-mobile.svg'} alt="graph-4-1"></img>
								</div>
								<div className="col-md-6 col-12 pr-md-4 mb-md-0 mb-lg-2 mb-lg-4 mt-lg-4 mx-auto text-center">
									<img className="pieGraph desktop addShadow" src={'/april-fools/Static5-Fire-signs-b.svg'} alt="graph-4-2"></img>
									<img className="pieGraph mobile addShadow" src={'/april-fools/Static5-Fire-signs-b-mobile.svg'} alt="graph-4-2"></img>
								</div>
							</div>
						</div>
						<div className="row mb-lg-6 mb-5 text-paragraph">
							<div className="col-12 two-columns">
								<p>Sagittarius’ were the lowest represented in the tech industry at 5% and ranked  among the highest paid. We suspect this is due to their mischievous yet optimistic approach to life, and being well liked by peers and colleagues.</p>
							</div>
						</div>
						<div className="business-meaning-container-bis-right">
							<img className="business-meaning-img" src="/april-fools/5-image-what-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left mb-1">What this means for your business:</h2>
								<p className="text-left mb-1">Create objective guardrails in performance reviews to reward all staff who do great work, not just those  who talk about it.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AReward%20all%20staff%20who%20do%20great%20work%20-%20not%20just%20the%20people%20who%20talk%20about%20it.%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AReward%20all%20staff%20who%20do%20great%20work%20-%20not%20just%20the%20people%20who%20talk%20about%20it.%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
								<img className="business-meaning-img desktopTablet" src="/april-fools/5-image-what-this-means.svg" alt="Cards business"></img>
							</div>
						</div>
						<div className="business-meaning-container-bis-right-mobile">
							<img className="business-meaning-img tablet" src="/april-fools/5-image-what-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left mb-1">What this means for your business:</h2>
								<p className="text-left mb-1">Create objective guardrails in performance reviews to reward all staff who do great work, not just those  who talk about it.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AReward%20all%20staff%20who%20do%20great%20work%20-%20not%20just%20the%20people%20who%20talk%20about%20it.%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%0A%0AReward%20all%20staff%20who%20do%20great%20work%20-%20not%20just%20the%20people%20who%20talk%20about%20it.%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
								<img className="business-meaning-img desktopTablet" src="/april-fools/5-image-what-this-means.svg" alt="Cards business"></img>
							</div>
						</div>
					</div>
				</section>

				{/* GET REPORT BOX */}
				<section className="getReport-box sectionSpacing">
					<div className="container" id="getReport">
						<div className="row">
							<div className="col-md-6 col-12 marginMobile">
								<p className="getReport--main--text">Download the full report</p>
								<p className="getReport--main--text">for deeper Astrological Insights.</p>
							</div>
							<div className="col-md-6 col-12">
								<DemoFormShortPDFAprilFools CBW pdfUrl={'/resources/Charting-Better-Galaxies-Report-ChartHop.pdf'} source={" resources-charting-better-galaxies-PDF-contentdownload-box3"} />
							</div>
						</div>
					</div>
				</section>

				{/* WATER SIGNS */}
				<section className="waterSignsSection sectionSpacing" id="waterSigns">
					<div className="container">
						<h2 className="text-center mb-lg-5 mb-4">3. Water Signs Dominate People-Facing Roles</h2>
						<div className="row align-items-center mb-md-6 mb-3">
							<div className="col-12 pr-md-2 mb-md-0 mb-3">
								<div className="graphContainer">
									<p className="graphicSubtitle text-left mb-2">Research found that <strong>Water Signs tend to gravitate towards people-facing roles,</strong> particularly Customer Success (50%), People/HR (60%), and Technical Support (45%).</p>
									<img src={'/april-fools/Static6-by-Department-desktop.svg'} className="desktop waterChart addShadow" alt="graph-6"></img>
									<img src={'/april-fools/Static6-by-Department.svg'} className="mobile addShadow" alt="graph-6"></img>
									<p className="text-left mt-2 chartDescription"> It is unclear whether Water Signs gravitate or are steered towards these roles. However, we hope that by shedding light on this trend, orgs may realize the need to have more Water Sign representation across departments where empathy is highly valued, like Sales and Marketing.</p>
								</div>
							</div>
						</div>
						<div className="business-meaning-container-bis-left water">
							<img className="business-meaning-img upper" src="/april-fools/6-image-Cards-What-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left">What this means for your business:</h2>
								<p className="text-left mb-4">Value empathy and compassion across all departments and levels.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0AValue%20empathy%20and%20compassion%20in%20all%20roles%20-%20not%20just%20people-facing%20ones%20%E2%9D%A4%EF%B8%8F%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0AValue%20empathy%20and%20compassion%20in%20all%20roles%20-%20not%20just%20people-facing%20ones%20%E2%9D%A4%EF%B8%8F%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>
						<div className="business-meaning-container-bis-left-mobile upper">
							<img className="business-meaning-img upper" src="/april-fools/6-image-Cards-What-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left">What this means for your business:</h2>
								<p className="text-left mb-4">Value empathy and compassion across all departments and levels.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0AValue%20empathy%20and%20compassion%20in%20all%20roles%20-%20not%20just%20people-facing%20ones%20%E2%9D%A4%EF%B8%8F%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0AValue%20empathy%20and%20compassion%20in%20all%20roles%20-%20not%20just%20people-facing%20ones%20%E2%9D%A4%EF%B8%8F%20%0A%0A%23RepresentationMatters%20%23DEI&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* AIR SIGN */}
				<section className="airSignSection sectionSpacing" id="airSigns">
					<div className="container">
						<h2 className="text-center mb-lg-5 mb-4">4. Air signs as inconsistent as ever</h2>
						<div className="row mb-lg-5 mb-3">
							<div className="col-12">
								<p>True to their nature, Air signs follow neither rhyme nor reason. They are all over the place in terms of department, seniority,
							and compensation.</p>
								<br></br>
								<p>However, the data becomes troubling when focusing on Libras. We found that, although Earth Signs as a whole are the lowest paid by
							sign type, <strong>Libras are outliers as the lowest paid out of every sign.</strong></p>
							</div>
						</div>

						<div className="col-12 pr-md-2 pr-0 pl-0 airChart">
							<div>
								<img src={'/april-fools/Static7-by-Astrological-Sign.svg'} className="desktop addShadow" alt="graph-8"></img>
								<img src={'/april-fools/air-signs-graph-mobile.svg'} className="mobile addShadow" alt="graph-8"></img>
							</div>
						</div>
						<p className="mt-2 mb-lg-1 mb-6 section-text">Due to their non-confrontational and peace-keeping nature, Libras are quite frankly unlikely to stick up for themselves in the
					workplace. They are consistently passed over for promotions and raises and likely need help advocating for themselves.</p>

						<div className="business-meaning-container-bis-right">
							<img className="business-meaning-img tablet" src="/april-fools/7-Image-What-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left mb-1">What this means for your business:</h2>
								<p className="text-left ">Compensate employees based on objective measures, not based on who asks for raises.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0ACompensate%20employees%20based%20on%20objective%20measures%2C%20not%20by%20who%20asks%20for%20raises%20%F0%9F%A4%91%0A%0A%23EqualPay%20%23PayEquality%20%23PayGap%20%23WageGap&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0ACompensate%20employees%20based%20on%20objective%20measures%2C%20not%20by%20who%20asks%20for%20raises%20%F0%9F%A4%91%0A%0A%23EqualPay%20%23PayEquality%20%23PayGap%20%23WageGap&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
								<img className="business-meaning-img desktopTablet" src="/april-fools/7-Image-What-this-means.svg" alt="Cards business"></img>
							</div>
						</div>
						<div className="business-meaning-container-bis-right-mobile">
							<img className="business-meaning-img tablet" src="/april-fools/7-Image-What-this-means.svg" alt="Cards business"></img>
							<div className="business-meaning-info">
								<h2 className="text-left mb-1">What this means for your business:</h2>
								<p className="text-left ">Compensate employees based on objective measures, not based on who asks for raises.</p>
								<div className="share-twitter">
									<div className="twitter-container">
										<p className="text-left desktopTablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0ACompensate%20employees%20based%20on%20objective%20measures%2C%20not%20by%20who%20asks%20for%20raises%20%F0%9F%A4%91%0A%0A%23EqualPay%20%23PayEquality%20%23PayGap%20%23WageGap&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
										<p className="text-center borderTop tablet"><a className="super" href="https://twitter.com/share?text=Words%20of%20wisdom%20from%20%40ChartHop%20%F0%9F%94%AE%20%0A%0ACompensate%20employees%20based%20on%20objective%20measures%2C%20not%20by%20who%20asks%20for%20raises%20%F0%9F%A4%91%0A%0A%23EqualPay%20%23PayEquality%20%23PayGap%20%23WageGap&amp;url=https://charthop.com/resources/guides-ebooks/charting-better-galaxies/&amp;hashtags=ChartingBetterGalaxies" target="_blank"><img src={'/april-fools/White-Twitter.svg'} alt="twitter" className="tweetIt"></img><span className="twitter-text">SHARE</span></a></p>
									</div>
								</div>
								<img className="business-meaning-img desktopTablet" src="/april-fools/7-Image-What-this-means.svg" alt="Cards business"></img>
							</div>
						</div>
					</div>
				</section>

				{/* GET REPORT BOX */}
				<section className="getReport-box sectionSpacing">
					<div className="container" id="getReport">
						<div className="row">
							<div className="col-md-6 col-12 marginMobile">
								<p className="getReport--main--text">Download the full report</p>
								<p className="getReport--main--text">for deeper Astrological Insights.</p>
							</div>
							<div className="col-md-6 col-12">
								<DemoFormShortPDFAprilFools CBW pdfUrl={'/resources/Charting-Better-Galaxies-Report-ChartHop.pdf'} source={"resources-charting-better-galaxies-PDF-contentdownload-box4"} />
							</div>
						</div>
					</div>
				</section>

				{/* CONCLUSION */}
				<section className="conclusionSection1 sectionSpacing" id="conclusionSection1">
					<div className="container">
						<h2 className="text-center titleConclusion">Conclusion</h2>
						<img className="conclusion-symbol1 desktop" src="/april-fools/conclusion-symbol1.svg" alt="conclusion-symbol1"></img>
						<img className="conclusion-symbol2 desktop" src="/april-fools/conclusion-symbol2.svg" alt="conclusion-symbol2"></img>
						<img className="conclusion-symbol3-2 desktop" src="/april-fools/conclusion-symbol3-star.svg" alt="conclusion-symbol3"></img>
						<img className="conclusion-symbol4 desktop" src="/april-fools/conclusion-symbol4.svg" alt="conclusion-symbol4"></img>
						<img className="conclusion-symbol3 desktop" src="/april-fools/conclusion-symbol3-star.svg" alt="conclusion-symbol3"></img>
						<div className="row">
							<div className="col-md-8 col-12 descriptionConclusion desktop">
								<p className="conclusionSubTitle">Our data paints a picture of the issues we must address to achieve the fairness and equity our society needs.</p>
								<br></br>
								<p><strong>Change requires action across the board</strong> -- from Leos and Geminis to Capricorns
							and Scorpios. Now that we know the problems that must be addressed, <strong>we have the opportunity to leverage this data for good.</strong></p>
								<br></br>
								<p>If you're a ChartHop Customer, you can get started now. <a href="/blog/product-updates/improve-working-relationships-astrology/">Check out your Astrology data</a> and get to know the trends in your own company. And <a href="/product/dei/">start tracking this data</a> across your team too.</p>
								<br></br>
								<p>Understand the gaps in your company, and in your industry. To continue the work, check out the Charting Better Workplaces Report to see how these metrics stack against gender and race.</p>
								<br></br>
								<p>Together, we can address inequities and create a better workplace for everyone under the stars.</p>
								<br></br>
							</div>
							<div className="descriptionConclusion mobile">
								<p className="conclusionSubTitle">Our data paints a picture of the issues we must address to achieve the fairness and equity our society needs.</p>
								<br></br>
								<p><strong>Change requires action across the board</strong> -- from Leos and Geminis to Capricorns
							and Scorpios. Now that we know the problems that must be addressed, <strong>we have the opportunity to leverage this data for good.</strong></p>
								<br></br>
								<p>If you're a ChartHop Customer, you can get started now. <a href="/blog/product-updates/improve-working-relationships-astrology/">Check out your Astrology data</a> and get to know the trends in your own company. And <a href="/product/dei/">start tracking this data</a> across your team too.</p>
								<br></br>
								<p>Understand the gaps in your company, and in your industry. To continue the work, check out the Charting Better Workplaces Report to see how these metrics stack against gender and race.</p>
								<br></br>
								<p>Together, we can address inequities and create a better workplace for everyone under the stars.</p>
								<br></br>
							</div>
							<div className="col-md-4 col-12 imageConclusion desktop">
								<img src="/april-fools/8-image-Conclusion.svg" alt="" />
							</div>
						</div>
						<div className="text-center readReport">
							<button type="submit" className="button primary">
								<a href="/resources/guides-ebooks/charting-better-workplaces/2020/" target="_blank">
									LET'S CHART BETTER WORKPLACES
								</a>
              				</button>
							<p className="fonts footerConclusion desktop"><strong>*This report was written by a  <img src="/april-fools/conclusion-gemini.svg" alt=""></img> Gemini Sun,  <img src="/april-fools/Conclusion-Aries.svg" alt=""></img> Aries Rising, and  <img src="/april-fools/Conclusion-Capricorn.svg" alt=""></img> Capricorn Moon.</strong></p>
							<p className="fonts footerConclusion mobile"><strong>*This report was written by a Gemini Sun, Aries Rising, and Capricorn Moon.</strong></p>
						</div>
					</div>
				</section>

				  {/* LONG FORM */}
				<section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"resources-charting-better-galaxies-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-1 contact-testimonial">"Companies spend millions trying to figure out if they have pay equity issues or gender gap issues.</p><p class=" mb-1 contact-testimonial">Now there will be no excuse because the data is sitting there -  you can push a button and get it."</p><div class="authorTag"><img src="/supporters/aileen-cowboy.png" class="testimonialAuthor" alt="Aileen Lee from Cowboy" /><div><p class="contactAuthor"><strong>Aileen Lee</strong> <br>Founder & Partner, Cowboy Ventures</p></div></div>')}/>
			</section>
			</div>
		</Layout>
	);
};

export default Home;